<template>
  <Table style="margin-top: 1rem" class="overdue-invoice-table">
    <TableHeader>
      <TableRow>
        <TableHead
          v-for="(overdueInvoiceSummaryCol,
          index) of overdueInvoiceSummaryColumns"
          :key="`${overdueInvoiceSummaryCol.label}_${index}`"
        >
          <span>{{ overdueInvoiceSummaryCol.label }}</span>
        </TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableRow
        v-for="(overdueInvoiceSummary, index) of overdueInvoiceSummaryList"
        :key="`${overdueInvoiceSummary.name}_${index}`"
      >
        <TableCell
          class="name-summary"
          :style="setInvoiceSummaryStatusColor(overdueInvoiceSummary.name)"
        >
          {{ overdueInvoiceSummary.name }}
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <div>
            <RenderMoneyColumnValue
              v-if="
                overdueInvoiceSummary.name.substring(2, 3) === '0' ||
                  ['B', 'K', 'T'].includes(
                    overdueInvoiceSummary.name.substring(2, 3),
                  )
              "
              :value="
                !['B', 'K', 'T'].includes(
                  overdueInvoiceSummary.name.substring(2, 3),
                )
                  ? getTotalAmountByStatusPrefix(
                      overdueInvoiceSummary.name.substring(1, 2),
                      overdueInvoiceSummaryList,
                    ) || 0
                  : overdueInvoiceSummary.total || 0
              "
              :max-fraction-digits="0"
            />
            |
            <RenderPercentageColumnValue
              :value="overdueInvoiceSummary.percentageOfTotal"
            />
          </div>
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <RenderMoneyColumnValue
            :max-fraction-digits="0"
            :value="overdueInvoiceSummary.subtotal"
          />
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByOverdueInvoiceList(
                overdueInvoiceSummary.january,
              )
            "
            :percentage-invoice-value="
              getSumPercentageByOverdueInvoiceList(
                overdueInvoiceSummary.january,
              )
            "
            :status="overdueInvoiceSummary.name"
          />
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByOverdueInvoiceList(
                overdueInvoiceSummary.february,
              )
            "
            :percentage-invoice-value="
              getSumPercentageByOverdueInvoiceList(
                overdueInvoiceSummary.february,
              )
            "
            :status="overdueInvoiceSummary.name"
          />
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByOverdueInvoiceList(overdueInvoiceSummary.march)
            "
            :percentage-invoice-value="
              getSumPercentageByOverdueInvoiceList(overdueInvoiceSummary.march)
            "
            :status="overdueInvoiceSummary.name"
          />
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByOverdueInvoiceList(overdueInvoiceSummary.april)
            "
            :percentage-invoice-value="
              getSumPercentageByOverdueInvoiceList(overdueInvoiceSummary.april)
            "
            :status="overdueInvoiceSummary.name"
          />
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByOverdueInvoiceList(overdueInvoiceSummary.may)
            "
            :percentage-invoice-value="
              getSumPercentageByOverdueInvoiceList(overdueInvoiceSummary.may)
            "
            :status="overdueInvoiceSummary.name"
          />
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByOverdueInvoiceList(overdueInvoiceSummary.june)
            "
            :percentage-invoice-value="
              getSumPercentageByOverdueInvoiceList(overdueInvoiceSummary.june)
            "
            :status="overdueInvoiceSummary.name"
          />
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByOverdueInvoiceList(overdueInvoiceSummary.july)
            "
            :percentage-invoice-value="
              getSumPercentageByOverdueInvoiceList(overdueInvoiceSummary.july)
            "
            :status="overdueInvoiceSummary.name"
          />
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByOverdueInvoiceList(
                overdueInvoiceSummary.august,
              )
            "
            :percentage-invoice-value="
              getSumPercentageByOverdueInvoiceList(overdueInvoiceSummary.august)
            "
            :status="overdueInvoiceSummary.name"
          />
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByOverdueInvoiceList(
                overdueInvoiceSummary.september,
              )
            "
            :percentage-invoice-value="
              getSumPercentageByOverdueInvoiceList(
                overdueInvoiceSummary.september,
              )
            "
            :status="overdueInvoiceSummary.name"
          />
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByOverdueInvoiceList(
                overdueInvoiceSummary.october,
              )
            "
            :percentage-invoice-value="
              getSumPercentageByOverdueInvoiceList(
                overdueInvoiceSummary.october,
              )
            "
            :status="overdueInvoiceSummary.name"
          />
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByOverdueInvoiceList(
                overdueInvoiceSummary.november,
              )
            "
            :percentage-invoice-value="
              getSumPercentageByOverdueInvoiceList(
                overdueInvoiceSummary.november,
              )
            "
            :status="overdueInvoiceSummary.name"
          />
        </TableCell>
        <TableCell class="overdue-invoice-table-cell">
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByOverdueInvoiceList(
                overdueInvoiceSummary.december,
              )
            "
            :percentage-invoice-value="
              getSumPercentageByOverdueInvoiceList(
                overdueInvoiceSummary.december,
              )
            "
            :status="overdueInvoiceSummary.name"
          />
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
</template>

<script>
/// <reference path="../../types/index.js" />

import {
  RenderMoneyColumnValue,
  RenderPercentageColumnValue,
} from '../../../../ui/render';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../../ui/table';
import { sumColumnValueByListAndColumn } from '../../../../utils';
import { RenderPanoramaSummaryInvoiceLine } from '../../../panorama/components';
import { setJudicialStatusColor } from '../../utils';

export default {
  components: {
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell,
    TableHeader,
    RenderMoneyColumnValue,
    RenderPercentageColumnValue,
    RenderPanoramaSummaryInvoiceLine,
  },
  props: {
    /**
     * Lista de Faturas Vencidas por status
     * @default []
     * @type {{ name: string, list: OverdueInvoice[], csvList: any }[]}
     */
    overdueInvoiceStatusList: {
      required: true,
      default: [],
      type: Array,
    },
  },
  data() {
    return {
      overdueInvoiceSummaryColumns: [
        {
          key: 'invoice',
          label: 'Fatura',
        },
        {
          key: 'total',
          label: 'Total',
        },
        {
          key: 'subtotal',
          label: 'Subtotal',
        },
        {
          key: 'january',
          label: 'Janeiro',
        },
        {
          key: 'february',
          label: 'Fevereiro',
        },
        {
          key: 'march',
          label: 'Março',
        },
        {
          key: 'april',
          label: 'Abril',
        },
        {
          key: 'may',
          label: 'Maio',
        },
        {
          key: 'june',
          label: 'Junho',
        },
        {
          key: 'july',
          label: 'Julho',
        },
        {
          key: 'august',
          label: 'Agosto',
        },
        {
          key: 'september',
          label: 'Setembro',
        },
        {
          key: 'october',
          label: 'Outubro',
        },
        {
          key: 'november',
          label: 'Novembro',
        },
        {
          key: 'december',
          label: 'Dezembro',
        },
      ],
      overdueInvoiceSummaryList: [],
    };
  },
  mounted() {
    this.overdueInvoiceSummaryList = this.parseOverdueInvoiceStatusListToOverdueInvoiceSummaryList(
      this.overdueInvoiceStatusList,
    );
  },
  methods: {
    /**
     * Retorna o total de porcentagem dado uma lista de Faturas atrasadas
     *
     * @param {OverdueInvoice[]} overdueInvoiceList
     * @returns {function(): number}
     */
    getSumPercentageByOverdueInvoiceList(overdueInvoiceList) {
      return sumColumnValueByListAndColumn(
        'percentageOfTotal',
        overdueInvoiceList,
      );
    },
    /**
     * Retorna o total dos valores de Boleto Veins dado uma lista de Faturas atrasadas
     *
     * @param {OverdueInvoice[]} overdueInvoiceList
     * @returns {function(): number}
     */
    getSumBoletoVeinsByOverdueInvoiceList(overdueInvoiceList) {
      return sumColumnValueByListAndColumn('boletoVeins', overdueInvoiceList);
    },
    /**
     * Converte uma lista de status de faturas vencidas em uma lista resumida de faturas vencidas, agrupadas por mês.
     *
     * @param {{ name: string, list: OverdueInvoice[], csvList: any }[]} overdueInvoiceStatusList
     * @returns {function(): OverdueInvoiceSummary[]}
     */
    parseOverdueInvoiceStatusListToOverdueInvoiceSummaryList(
      overdueInvoiceStatusList,
    ) {
      const statusMap = new Map();

      statusMap.set('TOTAL', {
        name: '[TT] Total',
        total: 0,
        subtotal: 0,
        qtyInvoceInStatus: 0,
        percentageOfTotal: 0,
        january: [],
        february: [],
        march: [],
        april: [],
        may: [],
        june: [],
        july: [],
        august: [],
        september: [],
        october: [],
        november: [],
        december: [],
      });

      for (const overdueInvoiceStatus of overdueInvoiceStatusList) {
        statusMap.set(overdueInvoiceStatus.name, {
          name: overdueInvoiceStatus.name,
          total: 0,
          subtotal: 0,
          qtyInvoceInStatus: 0,
          percentageOfTotal: 0,
          january: [],
          february: [],
          march: [],
          april: [],
          may: [],
          june: [],
          july: [],
          august: [],
          september: [],
          october: [],
          november: [],
          december: [],
        });
      }

      overdueInvoiceStatusList.forEach(overdueInvoice => {
        overdueInvoice.list.forEach(invoice => {
          const date = new Date(invoice.referenceDate);
          const abbreviatedMonth = new Intl.DateTimeFormat('en', {
            month: 'long',
          })
            .format(date)
            .toLowerCase();
          const statusSummary = statusMap.get(overdueInvoice.name);
          const totalStatus = statusMap.get('TOTAL');

          statusSummary.total += invoice.boletoVeins;
          statusSummary.subtotal += invoice.boletoVeins;
          statusSummary.qtyInvoceInStatus += 1;
          totalStatus.total += invoice.boletoVeins;
          totalStatus.subtotal += invoice.boletoVeins;
          totalStatus.qtyInvoceInStatus += 1;

          statusSummary[abbreviatedMonth].push(invoice);
          totalStatus[abbreviatedMonth].push(invoice);
        });
      });

      const totalOverall = statusMap.get('TOTAL').total;

      statusMap.forEach((statusSummary, status) => {
        statusSummary.percentageOfTotal =
          (statusSummary.total / totalOverall) * 100;

        const months = [
          'january',
          'february',
          'march',
          'april',
          'may',
          'june',
          'july',
          'august',
          'september',
          'october',
          'november',
          'december',
        ];
        months.forEach(month => {
          statusSummary[month] = statusSummary[month].map(entry => ({
            ...entry,
            percentageOfTotal: (entry.boletoVeins / statusSummary.total) * 100,
          }));
        });
      });

      return Array.from(statusMap.values());
    },
    /**
     * Calcula o valor total dos boletos vencidos para um determinado prefixo de status judicial.
     *
     * @param {string} statusPrefix - Prefixo do status judicial para filtrar (primeira letra do status).
     * @param {OverdueInvoiceSummary[]} overdueInvoiceSummaryList - Lista de resumos de faturas vencidas, agrupadas por status e mês.
     *
     * @returns {number} O valor total dos boletos vencidos para o prefixo de status especificado.
     *
     * @example
     * const total = getTotalAmountByStatusPrefix('L', overdueInvoiceSummaryList);
     * console.log(total); // Output: valor total dos boletos vencidos para status que começam com 'L'
     */
    getTotalAmountByStatusPrefix(statusPrefix, overdueInvoiceSummaryList) {
      let total = 0;
      overdueInvoiceSummaryList.forEach(overdueInvoice => {
        if (overdueInvoice.name.substring(1, 2) === statusPrefix) {
          total = total + overdueInvoice.subtotal;
        }
      });
      return total;
    },
    /**
     * Retorna o estilo CSS associado a um status de resumo de fatura específico.
     *
     * @param {string} name - O nome do status de resumo da fatura.
     * @returns {string} O estilo CSS associado ao status de resumo da fatura.
     */
    setInvoiceSummaryStatusColor(name) {
      return setJudicialStatusColor(name);
    },
  },
};
</script>

<style lang="scss" scoped>
.overdue-invoice-table-cell {
  height: 20px !important;
  text-align: end;
}

.name-summary {
  height: 20px !important;
}

.overdue-invoice-table {
  display: block;

  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    background-color: #e7e7e7;
  }

  td:nth-child(2),
  th:nth-child(2) {
    position: sticky;
    left: 5.5rem;
    background-color: #e7e7e7;
  }

  tr:nth-child(odd) td:nth-child(-n + 2) {
    background-color: #e7e7e7;
  }

  tr:nth-child(even) td:nth-child(-n + 2) {
    background-color: #f2f2f2;
  }
}
</style>
